import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export const ReturnAffectifFaq = () => (
<AccordionItem value="item-1" className="bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-900/40 rounded-xl px-6">
                <AccordionTrigger data-testid="faq-question-1" className="text-white hover:text-red-500 text-lg font-semibold">
                  Comment fonctionne le retour affectif du sorcier vaudou Maître Diamma ?
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 leading-relaxed">
                  <strong className="text-white">Maître Diamma</strong>, grand <strong className="text-red-400">sorcier vaudou</strong> authentique, 
                  utilise des rituels ancestraux de magie blanche, de magie rouge et de vaudou traditionnel pour créer un lien spirituel 
                  et émotionnel puissant entre vous et votre ex. Ces rituels de <strong className="text-yellow-400">retour affectif</strong> 
                  agissent sur le plan astral et énergétique pour ramener l'être aimé. Les premiers résultats sont généralement visibles 
                  sous 3 à 7 jours : votre ex commencera à penser à vous, vous contactera ou manifestera des signes d'intérêt. 
                  Le retour complet et définitif se produit sous 3 à 21 jours maximum selon la complexité de la situation.
                </AccordionContent>
              </AccordionItem>
);
